export enum Gender{
    Male = 'm',
    Female = 'f'
}
